import React, { Component, Suspense} from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'


import { Layout } from 'antd'

import '../css/App.css'


// import Nav from './Nav'
import Welcome from './Welcome'
import Document from './Document'
import Documents from './Documents'
import Search from './Search'
import SearchBox from './SearchBox'

const Nav = React.lazy(() => import('./Nav'));
// const Welcome = React.lazy(() => import('./Welcome'));
// const Document = React.lazy(() => import('./Document'));
// const Documents = React.lazy(() => import('./Documents'));
// const Search = React.lazy(() => import('./Search'));
// const SearchBox = React.lazy(() => import('./SearchBox'));

const { Header, Content, Sider } = Layout;

class App extends Component {
  
  state = {
    collapsed: false,
    is_mobile: false
  }
  
  componentDidMount(){
    
    if(window.innerWidth < 700)
      this.setState({
        collapsed: true,
        is_mobile: true
      })
    
  }
  
  toggle = () => {
    
    this.setState({
      collapsed: !this.state.collapsed,
    });
    
  }
  
  navClicked = () => {
    
    if(this.state.is_mobile)
      this.setState({ collapsed: true })
    
  }
  
  render(){

    return (

        <Router>
              
          <Layout>
            <Suspense fallback={<div>Loading...</div>}>
              <Sider width="250" collapsedWidth="0" collapsible collapsed={this.state.collapsed} onCollapse={(collapsed, type) => { this.toggle() }}>
                <Nav store={this.props.store} navLinkClicked={this.navClicked} />
              </Sider>
            </Suspense>
            <Layout>
              
              <Header style={{ background: '#fff' }}>
                <div className="moreLinks pull-right" style={{ height: 30 }}>
                  <a href="https://holdmyticket.com/sell" className="spot1">Learn more</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <a href="https://holdmyticket.com/help" className="spot1">Support</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <a href="https://holdmyticket.com/venues" className="spot1">Login</a>
                </div>
                <SearchBox />
              </Header>          
              
                <Content className="mainContent">

                  <Switch>
                    <Route exact path="/" render={(props) => <Welcome store={this.props.store} {...props} />} />
                    <Route exact path="/search" render={(props) => <Search store={this.props.store} {...props} />} />
                    <Route path="/doc/:id/:slug" render={(props) => <Document store={this.props.store} {...props} />} />
                    <Route exact path="/:folder1" render={(props) => <Documents store={this.props.store} {...props} />} />
                    <Route exact path="/:folder1/:folder2" render={(props) => <Documents store={this.props.store} {...props} />} />
                  </Switch>
                
                </Content>

            </Layout>
            
          </Layout>

        </Router>

    );

  }

}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js